import { includes } from 'lodash';

import {
  LAYOUT_NAME_MINIMAL,
  LAYOUT_NAME_EDITORIAL,
  LAYOUT_NAME_POSTCARD,
  LAYOUT_NAME_MAGAZINE,
  LAYOUT_NAME_TILED,
  LAYOUT_NAME_BRICK,
  LAYOUT_NAME_SIDE_BY_SIDE,
  LAYOUT_NAME_ONE_COLUMN,
  LAYOUT_NAME_FULL_POST,
  LAYOUT_NAME_MOBILE,
  LAYOUT_NAME_MOBILE_TEXT_ON_IMAGE,
} from '../constants/layouts';
import {
  LIST_NUMBER_OF_POSTS,
  LIST_NUMBER_OF_ROWS,
  LIST_MASONRY_NUMBER_OF_POSTS,
  POST_TITLE_COLOR_STANDARD,
  POST_TITLE_FONT_STANDARD,
  POST_TITLE_COLOR_TEXT_ON_IMAGE,
  POST_TITLE_FONT_TEXT_ON_IMAGE,
  POST_DESCRIPTION_COLOR_STANDARD,
  POST_DESCRIPTION_FONT_STANDARD,
  POST_DESCRIPTION_COLOR_TEXT_ON_IMAGE,
  POST_DESCRIPTION_FONT_TEXT_ON_IMAGE,
  POST_HOVER_COLOR_STANDARD,
} from '../constants/wix-params';
import {
  POST_LIST_COMPONENT_SIMPLE,
  POST_LIST_COMPONENT_MOBILE,
  ITEM_COMPONENT_LIST_ITEM,
} from '@wix/communities-blog-client-common';

const LAYOUT_CONFIG = {
  [LAYOUT_NAME_MINIMAL]: {
    listComponentName: POST_LIST_COMPONENT_SIMPLE,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE,
    postsNumberSettingsKey: LIST_NUMBER_OF_ROWS,
    postsPerRow: 3,
    itemConfig: {
      displayHeader: false,
      displayFooterIcons: true,
      lineCount: {
        withCover: {
          title: 2,
          description: 0,
        },
        withoutCover: {
          title: 3,
          description: 4,
        },
      },
    },
    fontSizes: {
      title: {
        start: 18,
      },
      description: {
        start: 16,
      },
    },
  },
  [LAYOUT_NAME_EDITORIAL]: {
    listComponentName: POST_LIST_COMPONENT_SIMPLE,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE,
    postsNumberSettingsKey: LIST_NUMBER_OF_ROWS,
    postsPerRow: 3,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: true,
      lineCount: {
        withCover: {
          title: 2,
          description: 0,
        },
        withoutCover: {
          title: 3,
          description: 4,
        },
      },
    },
    fontSizes: {
      title: {
        start: 22,
        min: 16,
        max: 22,
      },
      description: {
        start: 16,
        min: 12,
        max: 16,
      },
    },
  },
  [LAYOUT_NAME_POSTCARD]: {
    listComponentName: POST_LIST_COMPONENT_SIMPLE,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE_TEXT_ON_IMAGE,
    postsNumberSettingsKey: LIST_NUMBER_OF_ROWS,
    postsPerRow: 3,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: true,
      lineCount: {
        withCover: {
          title: 2,
          description: 0,
        },
        withoutCover: {
          title: 2,
          description: 0,
        },
      },
    },
    fontSizes: {
      title: {
        start: 22,
        min: 16,
        max: 22,
      },
      description: {
        start: 16,
      },
    },
  },
  [LAYOUT_NAME_MAGAZINE]: {
    listComponentName: POST_LIST_COMPONENT_SIMPLE,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE_TEXT_ON_IMAGE,
    postsNumberSettingsKey: LIST_NUMBER_OF_ROWS,
    postsPerRow: 2,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: false,
      lineCount: {
        withCover: {
          title: 2,
          description: 0,
        },
        withoutCover: {
          title: 2,
          description: 0,
        },
      },
    },
    fontSizes: {
      title: {
        start: 36,
        min: 26,
        max: 48,
      },
      description: {
        start: 16,
      },
    },
  },
  [LAYOUT_NAME_TILED]: {
    // listComponentName: PostListMasonry,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE,
    postsNumberSettingsKey: LIST_MASONRY_NUMBER_OF_POSTS,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: true,
      lineCount: {
        withCover: {
          title: 3,
          description: 3,
        },
        withoutCover: {
          title: 3,
          description: 3,
        },
      },
    },
    fontSizes: {
      title: {
        start: 26,
        min: 18,
        max: 28,
      },
      description: {
        start: 16,
        min: 12,
        max: 16,
      },
    },
  },
  [LAYOUT_NAME_BRICK]: {
    // listComponentName: PostListMasonry,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE,
    postsNumberSettingsKey: LIST_MASONRY_NUMBER_OF_POSTS,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: false,
      lineCount: {
        withCover: {
          title: 3,
          description: 3,
        },
        withoutCover: {
          title: 3,
          description: 3,
        },
      },
    },
    fontSizes: {
      title: {
        start: 22,
        min: 16,
        max: 22,
      },
      description: {
        start: 16,
        min: 12,
        max: 16,
      },
    },
  },
  [LAYOUT_NAME_SIDE_BY_SIDE]: {
    listComponentName: POST_LIST_COMPONENT_SIMPLE,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE,
    postsNumberSettingsKey: LIST_NUMBER_OF_POSTS,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: false,
      lineCount: {
        withCover: {
          title: 3,
          description: 2,
        },
        withoutCover: {
          title: 2,
          description: 2,
        },
      },
    },
    fontSizes: {
      title: {
        start: 28,
        min: 20,
        max: 28,
      },
      description: {
        start: 16,
        min: 12,
        max: 16,
      },
    },
  },
  [LAYOUT_NAME_ONE_COLUMN]: {
    listComponentName: POST_LIST_COMPONENT_SIMPLE,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    mobileLayout: LAYOUT_NAME_MOBILE,
    postsNumberSettingsKey: LIST_NUMBER_OF_POSTS,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: false,
      lineCount: {
        withCover: {
          title: 2,
          description: 2,
        },
        withoutCover: {
          title: 2,
          description: 2,
        },
      },
    },
    fontSizes: {
      title: {
        start: 28,
        min: 20,
        max: 28,
      },
      description: {
        start: 16,
        min: 12,
        max: 16,
      },
    },
  },
  [LAYOUT_NAME_FULL_POST]: {
    listComponentName: POST_LIST_COMPONENT_SIMPLE,
    // itemComponentName: Post,
    mobileLayout: LAYOUT_NAME_MOBILE,
    postsNumberSettingsKey: LIST_NUMBER_OF_POSTS,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: false,
    },
    fontSizes: {
      title: {
        start: 40,
      },
      description: {
        start: 18,
      },
    },
  },
  [LAYOUT_NAME_MOBILE]: {
    listComponentName: POST_LIST_COMPONENT_MOBILE,
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: true,
      lineCount: {
        withCover: {
          title: 3,
          description: 3,
        },
        withoutCover: {
          title: 3,
          description: 3,
        },
      },
    },
    fontSizes: {
      title: {
        start: 26,
        min: 18,
        max: 28,
      },
      description: {
        start: 16,
        min: 12,
        max: 16,
      },
    },
  },
  [LAYOUT_NAME_MOBILE_TEXT_ON_IMAGE]: {
    listComponentName: 'PostListMobile',
    itemComponentName: ITEM_COMPONENT_LIST_ITEM,
    itemConfig: {
      displayHeader: true,
      displayFooterIcons: true,
      lineCount: {
        withCover: {
          title: 2,
          description: 0,
        },
        withoutCover: {
          title: 2,
          description: 0,
        },
      },
    },
    fontSizes: {
      title: {
        start: 22,
      },
      description: {
        start: 12,
      },
    },
  },
};

export const FONT_COLOR_KEYS_STANDARD = {
  titleFontKey: POST_TITLE_FONT_STANDARD,
  titleColorKey: POST_TITLE_COLOR_STANDARD,
  descriptionFontKey: POST_DESCRIPTION_FONT_STANDARD,
  descriptionColorKey: POST_DESCRIPTION_COLOR_STANDARD,
  hoverColorKey: POST_HOVER_COLOR_STANDARD,
};

export const FONT_COLOR_KEYS_TEXT_ON_IMAGE = {
  titleFontKey: POST_TITLE_FONT_TEXT_ON_IMAGE,
  titleColorKey: POST_TITLE_COLOR_TEXT_ON_IMAGE,
  descriptionFontKey: POST_DESCRIPTION_FONT_TEXT_ON_IMAGE,
  descriptionColorKey: POST_DESCRIPTION_COLOR_TEXT_ON_IMAGE,
  hoverColorKey: POST_DESCRIPTION_COLOR_TEXT_ON_IMAGE,
};

export const isLayoutNameTextOnImage = (layoutName) =>
  includes([LAYOUT_NAME_POSTCARD, LAYOUT_NAME_MAGAZINE, LAYOUT_NAME_MOBILE_TEXT_ON_IMAGE], layoutName);
export const getLayoutConfig = (layout) => LAYOUT_CONFIG[layout];
export const getLineCounts = ({ lineCount }, isWithCover) =>
  isWithCover ? lineCount.withCover : lineCount.withoutCover;
